import { useEffect } from "react";

// O dropdown do Radix trava o scroll do body e, como o shell dimensiona por
// 100vw, a tabela encolhe alguns pixels. Reservar a calha mantém a largura.
export function useStableScrollbar() {
  useEffect(() => {
    const root = document.documentElement;
    const previous = root.style.scrollbarGutter;
    root.style.scrollbarGutter = "stable";
    return () => {
      root.style.scrollbarGutter = previous;
    };
  }, []);
}
